import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '& .IIImageSectionContainer': {
    height: theme.typography.pxToRem(382),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(369),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(185),
    },
  },
  '& .IIDistanceDisplay': {
    marginBottom: theme.spacing(2.25),
    color: theme.palette.text.secondary,
  },
}));
export default StyledBox;
